module.exports = __webpack_public_path__ + "img/qrcode.30267827.png";